<template>
  <div class="app" @click.stop="closeAllPopups">
    <AppHeader v-if="currentUser.id"
               @log-out="showLogOutConfirmation"
    />
    <AppMenu v-if="currentUser.id"
             @log-out="showLogOutConfirmation"
    />

    <AppAside v-if="currentUser.id && getMediaBreakpoint === 'desktop'"/>
    <router-view v-if="currentUser.id"/>

    <LoginForm v-if="!currentUser.logged_in"/>

    <transition name="fade">
      <ThePagePreloader position="app" v-if="currentUser.logged_in && userDataLoading" />
    </transition>

    <transition name="fade">
      <AppModal v-if="loginErrorIsActive"
                title="Ошибка авторизации!"
                text="Пожалуйста, авторизуйтесь повторно или обратитесь в поддержку"
                confirm-button-title="Закрыть"
                confirm-button-type="main"
                @confirm="hideLoginErrorMessage"
      />
    </transition>

    <div class="app-widget-wrap" v-if="currentUser.id">
      <transition name="fade" mode="out-in">
        <NotificationWidget v-if="getNotificationWidgetActive"/>
        <DialogWidget v-if="getDialogWidgetActive"/>
      </transition>
    </div>

    <!-- модалка подтверждения выхода -->
    <transition name="fade">
      <AppModal v-if="confirmation_active"
                title="Вы действительно хотите выйти из приложения?"
                confirm-button-type="main"
                confirm-button-title="Да"
                reject-button-type="alt"
                reject-button-title="Нет"
                @confirm="logOut"
                @reject="closeLogOutConfirmation"
      />
    </transition>
    <!-- /модалка подтверждения выхода -->

    <AlertList />
  </div>
</template>

<script>
import AlertList from '@/components/Alert/AlertList'
import AppHeader from './components/header/AppHeader.vue'
import AppMenu from './components/menu/AppMenu.vue'
import LoginForm from './components/page/modal/LoginForm'
import ThePagePreloader from './components/page/ThePagePreloader'
import AppAside from './components/aside/AppAside'
import AppModal from '@/components/page/modal/AppModal'
import NotificationWidget from '@/components/page/widget/NotificationWidget'
import DialogWidget from '@/components/page/widget/DialogWidget'
import { mapGetters } from 'vuex'

require('flatpickr/dist/flatpickr.css')
require('vue-multiselect/dist/vue-multiselect.min.css')
require('swiper/swiper-bundle.css')

export default {
  name: 'App',
  components: {
    AlertList,
    DialogWidget,
    NotificationWidget,
    AppModal,
    AppAside,
    ThePagePreloader,
    AppMenu,
    AppHeader,
    LoginForm
  },
  data () {
    return {
      confirmation_active: false
    }
  },

  watch: {
    numberOfNotifications (val) {
      if (val !== 0) {
        document.title = `${val} - intex`
      } else {
        document.title = 'intex'
      }
    }
  },

  computed: {
    ...mapGetters([
      'getNotificationWidgetActive',
      'getDialogWidgetActive',
      'getMediaBreakpoint',
      'currentUser',
      'currentUserData',
      'loginErrorIsActive',
      'getNewNotificationCounter',
      'getNewDialogCounter'
    ]),

    // нужно прикрывать интерфейс прелоадером, пока данные пользователя не загрузились
    userDataLoading () {
      return this.currentUserData.isLoading
    },

    numberOfNotifications () {
      const notificationCounter = +this.getNewNotificationCounter || 0
      const dialogCounter = +this.getNewDialogCounter || 0
      return notificationCounter + dialogCounter
    }
  },
  methods: {
    closeAllPopups () {
      this.$store.dispatch('closeAllPopups')
    },
    showLogOutConfirmation () {
      this.confirmation_active = true
    },
    closeLogOutConfirmation () {
      this.confirmation_active = false
    },
    hideLoginErrorMessage () {
      this.$store.commit('HIDE_LOGIN_ERROR_MESSAGE')
    },
    logOut () {
      this.$store.dispatch('logOut')
      this.confirmation_active = false
    },
    isAuthorized () {
      this.$store.dispatch('[dictionaries] getTaskProcessTypes')
      this.$store.dispatch('[dictionaries] getApproveProcessTypes')
    }
  },
  mounted () {
    this.$store.dispatch('checkLoggedUser')
    this.$store.dispatch('setCurrentMediaBreakPoint')
    this.$store.dispatch('setCurrentUserAgent')
    if (this.currentUser.logged_in) this.isAuthorized()
  }
}
</script>

<style lang="scss">
//.loadingData {
//  cursor: progress !important;
//  pointer-events: none !important;
//}

</style>
